<template>
  <div>
    <pop-up
      v-if="$consentManager.getConsentValue('preference')"
      :searchQuery="searchQuery"
    />
    <div class="pb-5">
      <main-jumbotron :key="searchQuery" />
      <Loader :text="searchQuery" v-if="loading" :loading="loading" />
      <b-container v-else>
        <h1 class="mb-3 meta-header">
          All HS Codes or HSN Codes for <b>{{ searchQuery }}</b> with GST Rates
        </h1>
        <b-container>
          <b-row>
            <b-col :xs="12" :lg="9">
              <div v-for="(result, i) in searchResult" :key="i">
                <search-table
                  :eights="result"
                  :code="i"
                  :isFirst="isFirst(i)"
                />
              </div>
            </b-col>
            <b-col :xs="12" :lg="3">
              <div class="banner-wrapper">
                <div class="world-image">
                  <b-img-lazy
                    :src="require(`../assets/images/world-map-banner.png`)"
                    alt="World Map"
                    height="100%"
                    class="world-image"
                  />
                </div>
                <div class="heading">
                  Get Fast Access to Cash without Collateral
                </div>
                <div class="sub-text">
                  Instant Disbursal | High Credit Limit | Lowest Rates |
                  Paperless | Transparent
                </div>
                <b-button
                  href="https://www.dripcapital.com/en-in/exporters/apply"
                  variant="secondary"
                  class="mt-4"
                  >Get Quote</b-button
                >
              </div>
            </b-col>
          </b-row>
        </b-container>
        <h5 class="pb-5 mb-5" v-if="Object.keys(searchResult).length === 0">
          No Results Found
        </h5>
      </b-container>
    </div>
  </div>
</template>

<script>
import MainJumbotron from '@/components/MainJumbotron'
import SearchTable from '@/components/SearchTable'
import { hsnQueryMixin } from '@/mixins/query'
import Loader from '@/components/Loader'
import PopUp from '@/components/Popup'

// URL - /hsn-code/search/XXX
export default {
  data() {
    return {
      searchResult: [],
      loading: false
    }
  },
  metaInfo() {
    const canonicalUrl = `https://www.dripcapital.com/hsn-code/search/${this.searchQuery}`
    return {
      title: `${this.searchQuery} HSN Code or HS Codes with GST Rate`,
      meta: [
        {
          vmid: 'description',
          name: 'description',
          content: `Find all HS Codes or HSN Codes for ${this.searchQuery} and its GST rate with Drip Capital's HSN Code finder.`
        }
      ],
      link: [{ rel: 'canonical', href: canonicalUrl }]
    }
  },
  props: ['searchQuery'],
  methods: {
    isFirst(code) {
      return Object.keys(this.searchResult)[0] === code
    }
  },
  watch: {
    async $route() {
      await this.hsnQuery()
    }
  },
  async created() {
    await this.hsnQuery()
  },
  components: {
    SearchTable,
    MainJumbotron,
    Loader,
    PopUp
  },
  mixins: [hsnQueryMixin]
}
</script>

<style lang="scss" scoped>
.meta-header {
  font-size: 1.5rem;
}

.banner-wrapper {
  background: $search-world-banner;
  text-align: center;
  padding: 20px;
  box-shadow: 0 2px 5px #0000000d;
  border: 1px solid $tradeview-card-color;
  border-radius: 4px;
  top: 6.5rem;
  position: sticky;

  .heading {
    color: $secondary;
    font-weight: bold;
    font-size: 1.4rem;
    margin-bottom: 20px;
  }

  .sub-text {
    color: $grey-sub-text;
  }
}

.world-image {
  height: 100%;
  width: 100%;
  max-height: 250px;
}
</style>
